<div class="create-survey-job-component">
    <div class="create-job-tools-bar">
        <panel-header
            [headerTitle]="headerTitle"
            [disableBackAction]="isJobCreationInProgress"
            (backClick)="backActionHandler()"
        >
        </panel-header>
    </div>
    <ng-container *ngIf="!isAttachFilesView">
        <div class="loading-overlay" *ngIf="isJobCreationInProgress || loading">
            <loading class="loading-align-center"></loading>
        </div>
        <gsp-notification *ngIf="!canCreateSurveyJob" [type]="NotificationType.Error"
            >{{ 'Survey.SurveyCreatePanel.ErrorTooltip' | translate }}, &nbsp;
            <a [href]="settingsPageUrl" target="_blank">
                {{ 'TC.Projects.Creation.Options.ProjectSettings' | translate }}
            </a></gsp-notification
        >
        <div
            class="create-job-content-wrapper"
            [style.height]="!canCreateSurveyJob ? 'calc(100% - 124px - 35px)' : 'calc(100% - 124px)'"
            *ngIf="!loading"
        >
            <custom-scroll>
                <ng-form #surveyJobNameForm="ngForm">
                    <div class="create-job-content">
                        <div class="job-name-group">
                            <h4 class="job-name-label create-job-label job-detail-title">
                                {{ 'TC.Common.Name' | translate }}
                            </h4>
                            <div class="job-name-input">
                                <gsp-text
                                    #jobNameInput="ngModel"
                                    class="job-name-input-field"
                                    [ngModel]="newJob.name"
                                    (ngModelChange)="onNameInputChange($event)"
                                    (keydownEvent)="blockInvalidChars($event)"
                                    [name]="'jobNameInput'"
                                    length="32"
                                    required="true"
                                    errorTooltipMsg="{{ getErrorText(jobNameInput.errors) }}"
                                    surveyJobNameValidator
                                ></gsp-text>
                            </div>
                        </div>
                        <div class="job-description-group">
                            <h4 class="job-description-label create-job-label job-detail-title">
                                {{ 'TC.Common.Description' | translate }}
                            </h4>
                            <div class="job-description">
                                <gsp-text-area
                                    class="job-description-input-field"
                                    [value]="newJob.description"
                                    (valueChange)="onDescriptionInputChange($event)"
                                    [maxLength]="32"
                                ></gsp-text-area>
                            </div>
                        </div>

                        <div class="job-assigned-user">
                            <edit-job-assigned-user
                                [job]="newJob"
                                (userChange)="onAssignedUserChange($event)"
                            ></edit-job-assigned-user>
                        </div>

                        <div class="job-tags">
                            <edit-job-tags
                                [jobTags]="newJob.tags"
                                (jobTagsChange)="onTagsInputChange($event)"
                            ></edit-job-tags>
                        </div>

                        <div class="job-linked-project-data">
                            <edit-linked-project-files
                                [linkedFiles]="this.newJob.linkedFiles"
                                (linkedFilesChange)="onLinkedFilesInputChange($event, true)"
                            ></edit-linked-project-files>
                        </div>
                    </div>
                </ng-form>
            </custom-scroll>
        </div>
        <div class="create-job-panel-footer">
            <gsp-button
                [type]="ButtonType.Default"
                text="{{ 'cancel' | translate }}"
                (action)="cancelCreateAction()"
            ></gsp-button>
            <gsp-button
                [type]="!canCreateSurveyJob ? ButtonType.Danger : ButtonType.Primary"
                [disabled]="!isJobNameEntered() || !canCreateSurveyJob"
                text="{{ 'Survey.SurveyCreatePanel.CreateJob' | translate }}"
                (action)="createJob()"
            ></gsp-button>
        </div>
    </ng-container>

    <div class="job-attach-files" *ngIf="isAttachFilesView">
        <attach-files
            class="attach-files-panel-wrapper"
            [files]="this.newJob.linkedFiles"
            (filesSelected)="onLinkedFilesInputChange($event)"
        ></attach-files>
    </div>
</div>
